var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "archive-expertise-articles"
    }
  }, [_c('section', {
    staticClass: "articles-archived block--gray block--padding-60"
  }, [_c('div', {
    staticClass: "block--heading-select has-thumb"
  }, [_c('h2', {
    staticClass: "titler"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (false) ? _c('catdropdown', {
    attrs: {
      "dataList": _vm.categoried,
      "selection": _vm.currentCategory
    },
    on: {
      "update:selection": function($event) {
        _vm.currentCategory = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "thumb-bg",
    style: (_vm.postThumb)
  })], 1), _vm._v(" "), (_vm.userErrorInfo) ? _c('div', {
    staticClass: "message message--info"
  }, [_vm._v(_vm._s(_vm.userErrorInfo))]) : _vm._e(), _vm._v(" "), (_vm.posts) ? _c('transition-group', {
    staticClass: "post-list-archived",
    attrs: {
      "name": "enter-list",
      "tag": "ul"
    },
    on: {
      "enter": _vm.enterAnimationListStagged,
      "before-enter": _vm.beforeEnterAnimation,
      "leave": _vm.leaveAnimationListStagged
    }
  }, _vm._l((_vm.posts), function(post, key) {
    return _c('li', {
      key: post.id,
      staticClass: "list-post-item",
      attrs: {
        "data-index": key
      }
    }, [_c('singlepost', {
      attrs: {
        "postdata": post
      }
    })], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.loadingPosts) ? _c('preloader', {
    staticClass: "posts-preload"
  }) : _vm._e(), _vm._v(" "), ((_vm.currentPage < _vm.maxPages)) ? _c('div', {
    staticClass: "text--center text--uppercase load-button-block"
  }, [_c('button', {
    staticClass: "btn btn--text",
    on: {
      "click": _vm.loadPosts
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.buttonLoadLabel) + "\n\t\t\t"), _c('span', {
    staticClass: "load-icon"
  }, [_c('svg', {
    attrs: {
      "width": "24px",
      "height": "20px",
      "viewBox": "0 0 24 20",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Arkiv-aktuelt",
      "transform": "translate(-524.000000, -1634.000000)",
      "fill-rule": "nonzero",
      "fill": "#000000"
    }
  }, [_c('g', {
    attrs: {
      "id": "Group-8",
      "transform": "translate(353.000000, 1632.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "refresh51",
      "transform": "translate(171.000000, 2.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.8181818,18.1818182 C8.99363636,18.1818182 6.50363636,16.75 5.03272727,14.5736364 L2.92272727,14.5736364 C4.58363636,17.7963636 7.94363636,20 11.8181818,20 C17.0345455,20 21.3181818,16.0054545 21.7772727,10.9090909 L23.6363636,10.9090909 L20.9090909,7.27272727 L18.1818182,10.9090909 L19.95,10.9090909 C19.4981818,15 16.03,18.1818182 11.8181818,18.1818182 Z",
      "id": "Shape"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.8181818,0 C6.91636364,0 2.83818182,3.52727273 1.98272727,8.18181818 L0,8.18181818 L2.72727273,11.8181818 L5.45454545,8.18181818 L3.83909091,8.18181818 C4.66545455,4.53818182 7.92454545,1.81818182 11.8181818,1.81818182 C14.2790909,1.81818182 16.4854545,2.90454545 17.9854545,4.62363636 L18.3363636,4.53363636 L20.1927273,4.53363636 C18.4072727,1.80363636 15.3236364,0 11.8181818,0 Z",
      "id": "Shape"
    }
  })])])])])])])])]) : _vm._e()], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f869b57a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/vue/ExpertiseArchivesArticles.vue
// module id = 234
// module chunks = 0